module.exports = __webpack_public_path__ + "img/finance_21.93525e71.png";